module.exports = __webpack_public_path__ + "img/IMG-20200919-WA0111.9b2a8b52.jpg";